const createFactoringCompany = company => async (
  dispatch,
  getState,
  { api, schema }
) => {
  await api.groups.createFactoringCompany(company);
};

export default createFactoringCompany;
